import { forwardRef } from "react";
import { cn } from "~/lib/utils";

export interface StatCardProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  value: string | number;
  icon: React.ReactNode;
}

const StatCard = forwardRef<HTMLDivElement, StatCardProps>(
  ({ className, label, value, icon, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col gap-2 rounded-md border border-[#e8e8ec] bg-white/80 p-4 sm:p-5",
          className
        )}
        {...props}
      >
        <div className="flex w-full items-start gap-2">
          <div className="flex flex-1 flex-col gap-1 sm:gap-2">
            <p className="text-xs sm:text-sm leading-4 sm:leading-5 text-[#60646c]">
              {label}
            </p>
            <div className="flex items-baseline gap-3">
              <p className="text-xl sm:text-[28px] font-semibold leading-7 sm:leading-9 tracking-[-0.12px] text-[#1c2024]">
                {value}
              </p>
            </div>
          </div>
          <div className="flex h-8 w-8 sm:h-10 sm:w-10 shrink-0 items-center justify-center rounded-md border border-[rgba(0,116,221,0.09)] bg-[rgba(0,85,199,0.04)]">
            {icon}
          </div>
        </div>
      </div>
    );
  }
);

StatCard.displayName = "StatCard";

export { StatCard };
